import { SpinWheelRewardType } from '../../Constants/Reward';
import { PlayerTask } from './PlayerTasks';
import { IMissionData } from './IMission';

export interface ILevelDataMap {
    /**
     * Regular levels (map nodes).
     */
    saga: ILevelData[];
    /**
     * Weekly Ticket Challenge levels, probably will be replace every week.
     */
    challenge: ILevelData[];
}

export interface ILevelData {
    /**
     * Level number.
     */
    levelNumber: number;
    /**
     * The number of stars earned after complete the level (1-3).
     */
    stars: number;
    /**
     * The number of level attempts per the current session.
     */
    attempts: number;
    /**
     * The number of level attempts per session, since last helper-friend activated.
     */
    helperFriendAttempts: number;
}

export interface IFriendData {
    playerId: string;
    lifeSendTimer?: string;
    lifeRequestTimer?: string;
    giftTimer?: string;
    helperTimer?: string;
}

export interface IPlayerStateInventoryData {
    boosterTNT: number;
    boosterBullsEye: number;
    boosterShuffle: number;
    boosterUndo: number;
    boosterJoker: number;
    boosterPlusFive: number;
    extraCards: number;
}

export interface IPlayerStateTaskData {
    task?: PlayerTask;
    [key: string]: any;
}

export enum UnlockType {
    SUITCASE = 'suitcase',
    BOOSTER_TNT = 'booster_tnt',
    BOOSTER_BULLS_EYE = 'booster_bulls_eye',
    BOOSTER_SHUFFLE = 'booster_shuffle',
    CHEST = 'chest',
    POSTCARD = 'postcard',

    // TODO: Persist in player save data.
    FREE_JOKER_BOOSTERS = 'free_jokers_boosters',

    // TODO: Persist in player save data.
    FREE_UNDO_BOOSTERS = 'free_jokers_boosters',
}

export interface IPlayerUnlock {
    type: UnlockType;
    id?: string;
}

export interface IChestUnlock extends IPlayerUnlock {
    type: UnlockType.CHEST;
    id: string;
}

export interface IPostcardUnlock extends IPlayerUnlock {
    type: UnlockType.POSTCARD;
    id: string;
}

export type PlayerUnlock = IPlayerUnlock | IChestUnlock | IPostcardUnlock;

export interface IPlayerFlag {
    id: string;
    date: string;
    expiryDate?: string;
}

export interface IPlayerState {
    coins: number;
    lives: number;
    keys: number;
    world: number;
    levels: ILevelDataMap;
    gateFriends: string[];
    receivedMessageIDs: string[];
    inventory: IPlayerStateInventoryData;
    backcard: string;
    backcards: number[];
    missions: IMissionData[];
    wheelSpins: number;
    friendData: IFriendData[];
    lifeShareCount: number;
    playerUnlocks: PlayerUnlock[];
    tasks: IPlayerStateTaskData[];

    optInReward: number;
    dataRestoreReward: number;
    shortcutReward: number;
    dataRestoreCounter: number;

    // Timers
    lifeTimer: string;
    gateTimer: string;
    missionTimer: string;
    keyMissionTimer: string;
    lifeSharePrizeTimer: string;
    wheelTimer: string;
    foxTimer: string;

    // Audio
    volumeSFX: number;
    volumeMusic: number;

    pushNotifications: number;

    gdprCompliance: number;

    // Other

    /**
     * The world the player is currently on.
     */
    activeWorld: number;

    /**
     * Keep track of the previous coins value to fix the coins display when returning to the world map.
     * This value is set when a level is completed BEFORE any coins are earned.
     */
    previousCoinsValue: number;

    /**
     * True if this player has never played the game before.
     */
    FTUE: boolean;

    /**
     * Store some flags and when they were added.
     * Should be mainly used for events.
     */
    flags: IPlayerFlag[];

    spinWheelTask: IPlayerStateTaskData[];
    spinWheelRewardType: SpinWheelRewardType;

    purchases: number;
}

export const initialPlayerState: IPlayerState = {
    coins: 1000,
    lives: 5,
    keys: 0,
    world: 1,
    levels: {
        saga: [],
        challenge: [],
    },
    gateFriends: [],
    receivedMessageIDs: [],
    inventory: {
        boosterTNT: 0,
        boosterBullsEye: 0,
        boosterShuffle: 0,
        boosterUndo: 0,
        boosterJoker: 0,
        boosterPlusFive: 0,
        extraCards: 0,
    },
    backcard: null,
    backcards: [],
    missions: [],
    wheelSpins: 0,
    friendData: [],
    lifeShareCount: 0,
    playerUnlocks: [],
    tasks: [],

    optInReward: 0,
    dataRestoreReward: 0,
    shortcutReward: 0,
    dataRestoreCounter: 0,

    lifeTimer: null,
    gateTimer: null,
    missionTimer: null,
    keyMissionTimer: null,
    lifeSharePrizeTimer: null,
    wheelTimer: null,
    foxTimer: null,

    volumeSFX: 1,
    volumeMusic: 1,

    pushNotifications: 1,

    gdprCompliance: 0,

    activeWorld: 1,
    previousCoinsValue: 0,
    FTUE: null,
    flags: [],
    spinWheelTask: [],
    spinWheelRewardType: null,

    purchases: 0,
};
